import { Navigate, useLocation } from "react-router-dom";
import { ADMIN_ROUTES } from "../../routes";

// Deprecated alias for the org list. Preserves the query string so bookmarked
// filter/search/page URLs keep working after the move to /admin/orgs.
export const AdminOverviewRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: ADMIN_ROUTES.AdminOrgs, search }} replace />;
};
